// --- Storefront API Configuration ---
const shopDomain = 'b71363-2.myshopify.com';
const accessToken = 'c7e9ab705eb8f3c0d093b2f156b96c21';
const endpoint = `https://${shopDomain}/api/2023-07/graphql.json`;

const statusMessages = document.querySelectorAll('.kit-search-status');
const searchButtons = document.querySelectorAll('.kit-search-button');

const query = `
    query($skuQuery: String!, $namespace: String!, $key: String!) {
        products(first: 50, query: $skuQuery) {
            edges {
                node {
                    id
                    title
                    onlineStoreUrl
                    variants(first: 100) {
                        edges {
                            node {
                                sku
                            }
                        }
                    }
                    metafield(namespace: $namespace, key: $key) {
                        value
                    }
                }
            }
        }
    }
`;

function findProductBySku(sku) {
    const variables = { skuQuery: sku, namespace: 'custom', key: 'recommended_spares' };
    return new Promise((resolve, reject) => {
        fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': accessToken
            },
            body: JSON.stringify({
                query,
                variables
            })
        })
        .then(response => response.json())
            .then(data => {
                if (data.errors) {
                    reject(data.errors);
                } else {
                    const products = data.data.products.edges;
                    if (products.length > 0) {
                        for (const product of products) {
                            for (const variant of product.node.variants.edges) {
                                if (variant.node.sku.toLowerCase() === sku.toLowerCase()) {
                                    resolve(product.node);
                                    return;
                                }
                            }
                        }
                        reject(new Error(`No product found with SKU: ${sku}`));

                    } else {
                        reject('No products found');
                    }
                }
            })
        .catch(error => {
            reject(error);
        });
    });
}

async function searchByModelNumber(event, form) {
    try {
        event.preventDefault();
        statusMessages.forEach(message => {
            message.style.color = 'black';
            message.innerHTML = 'Searching...';
        });
        searchButtons.forEach(button => button.disabled = true);
        const searchResults = await findProductBySku(form.elements.q.value);
        if (!!searchResults.metafield) {
            const index = searchResults.onlineStoreUrl.indexOf('.com');
            const productPathname = searchResults.onlineStoreUrl.substring(index + 4);
            const currentURL = new URL(window.location.href);
            if (currentURL.pathname === productPathname) {
                document.getElementById('recommended-spares').classList.add('active');
                statusMessages.forEach(message => {
                    message.style.color = 'black';
                    message.innerHTML = 'Search By Model Number';
                });
                searchButtons.forEach(button => button.disabled = false);
            }
            window.location.assign(productPathname + '#recommended-spares');
        } else {
            window.location.assign(`/pages/operation-service-manuals?query=${form.elements.q.value}&noSpares=true`)
        }
    }
    catch (err) {
        console.error(err);
        statusMessages.forEach(message => {
            message.style.color = 'red';
            message.innerHTML = 'No products found. Please enter a valid model number.';
        });
        searchButtons.forEach(button => button.disabled = false);
    }
}

function init() {
    const kitSearchForms = document.querySelectorAll('.kit-search');
    kitSearchForms.forEach(form => {
        form.addEventListener('submit', (event) => searchByModelNumber(event, form));
    });
}

init();